<template>
  <div style="display:grid; min-height:100vh;">
    <!-- <loading
          :active.sync="isLoading"
          :can-cancel="false"
          loader="dots"
          :is-full-page="fullPage"
          :height="height"
          :width="width"
          background-color="#6b6969"
        ></loading>-->
    <navbar />

    <!--    <div-->
    <!--      class="page-header header-filter clear-filter"-->
    <!--      style="background-image: url('./assets/img/home1.png');"-->
    <!--    >-->
    <!--      <div class="container header-container" style="margin-top:150px;">-->
    <!--        <div class="row">-->
    <!--          <div class="col-md-8">-->
    <!--            <h1 class="font-weight-bold text-deep_orange h1-text">-->
    <!--              Connecting &-->
    <!--              <br />Impacting Ladies <br />Through Technology-->
    <!--            </h1>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="section bg-green">-->
    <!--      <VueSlickCarousel :arrows="true" :dots="true">-->
    <!--        <div>1</div>-->
    <!--        <div>2</div>-->
    <!--        <div>3</div>-->
    <!--        <div>4</div>-->
    <!--      </VueSlickCarousel>-->
    <!--    </div>-->
    <div
      id="carouselExampleIndicators"
      class="carousel carousel-fade"
      data-ride="carousel"
      data-interval="50000"
    >
      <ol class="carousel-indicators">
        <li
          data-target="#carouselExampleIndicators"
          data-slide-to="0"
          class="active"
        />
        <li
          data-target="#carouselExampleIndicators"
          data-slide-to="1"
          class=""
        />
        <li
          data-target="#carouselExampleIndicators"
          data-slide-to="2"
          class=""
        />
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img
            class="d-block w-100 img-fluid"
            src="../../public/assets/img/slider-3.png"
            alt="home-slide-3"
          />
          <div class="carousel-caption">
            <h1 class="font-weight-bold text-deep_orange h1-text">
              Are you a past GTL
              <br />trainee? apply to <br />
              be a member
            </h1>
            <router-link to="/membership-application">
              <button class="btn btn-orange pl-5 pr-5 mt-4 d-none d-md-block">
                Apply Now
              </button>
            </router-link>
          </div>
        </div>
        <div class="carousel-item">
          <img
            class="d-block w-100 img-fluid"
            src="../../public/assets/img/slider-2.png"
            alt="home-slide-2"
          />
          <div class="carousel-caption">
            <h1 class="font-weight-bold text-deep_orange h1-text">
              Want to impact
              <br />knowledge Unto others? <br />apply to be a mentor
            </h1>
            <button class="btn btn-orange pl-5 pr-5 mt-4 d-none d-md-block">
              Apply Now
            </button>
          </div>
        </div>
        <div class="carousel-item ">
          <div class="carousel-caption">
            <h1 class="font-weight-bold text-deep_orange h1-text">
              Connecting &
              <br />Impacting Ladies <br />Through Technology
            </h1>
            <button class="btn btn-orange pl-5 pr-5 mt-4 d-none d-md-block">
              Learn More
            </button>
          </div>

          <img
            class="d-block w-100 img-fluid"
            src="../../public/assets/img/slider-1.png"
            alt="home-1"
          />
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <i class="material-icons">keyboard_arrow_left</i>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <i class="material-icons">keyboard_arrow_right</i>
        <span class="sr-only">Next</span>
      </a>
    </div>

    <div class="section section-basic about">
      <div class="custom-container-fluid">
        <div class="row">
          <div class="col-md-6 d-none d-md-none d-lg-block">
            <div style="display: flex; flex-direction: row; flex-wrap: wrap">
              <div class="mr-4">
                <img
                  src="../../public/assets/img/who-1.png"
                  style="width: 155px; height: 155px"
                  class="card-img-top"
                  alt="..."
                />
              </div>
              <div
                class="card mt-0 text-center bg-green"
                style="width: 155px; height: 155px"
              >
                <div class="card-body">
                  <h3 class="font-weight-bold">414</h3>
                  <h5 class="font-weight-bold">Members</h5>
                </div>
              </div>
            </div>
            <div
              style="display: flex; flex-direction: row; align-items:flex-end; flex-wrap: wrap-reverse;"
            >
              <div class="mr-4">
                <img
                  src="../../public/assets/img/who-2.png"
                  style="width: 155px; height: 155px"
                  class="card-img-top"
                  alt="..."
                />
              </div>
              <div
                class="card mt-0 mb-0 text-center mr-4 bg-green"
                style="width: 155px; height: 155px"
              >
                <div class="card-body">
<!--                  <h3 class="font-weight-bold">{{ (events || []).length }}</h3>-->
                  <h3 class="font-weight-bold">63</h3>
                  <h5 class="font-weight-bold">Events Organized</h5>
                </div>
              </div>
              <div class="mr-4">
                <img
                  src="../../public/assets/img/who-3.png"
                  style="width: 175px; height: 175px; object-fit: cover"
                  class="card-img-top"
                  alt="..."
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 d-lg-none d-xl-none">
            <div class="row">
              <div class="col-6">
                <img
                  src="../../public/assets/img/who-1.png"
                  class="card-img-top img-fluid"
                  alt="..."
                />
              </div>
              <div class="col-6">
                <div class="card mt-0 text-center bg-green">
                  <div class="card-body">
<!--                    <h3 class="font-weight-bold">-->
<!--                      {{ (members || []).length }}-->
<!--                    </h3>-->
                    <h3 class="font-weight-bold">
                      414
                    </h3>
                    <h5 class="font-weight-bold">Members</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <img
                  src="../../public/assets/img/who-2.png"
                  class="card-img-top img-fluid"
                  alt="..."
                />
              </div>
              <div class="col-3">
                <img
                  src="../../public/assets/img/who-3.png"
                  class="card-img-top img-fluid"
                  alt="..."
                />
              </div>
              <div class="col-6">
                <div class="card mt-0 mb-0 text-center bg-green">
                  <div class="card-body">
                    <h3 class="font-weight-bold">
                      63
                    </h3>
                    <h5 class="font-weight-bold">Events Organized</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h2 class="pt-4 font-weight-bold text-green">
              WHO WE ARE
            </h2>
            <h4 class="text-justify">
              The <b>Ghana Ladies in Tech Initiative</b> seeks to create a
              community of tech-savvy ladies to engage them in different
              activities that will help transform, enhance and enrich their
              entrepreneurial journeys, transforming their businesses into
              competitive enterprises across the globe.
            </h4>
            <h4>
              Our goal is to improve the general quality of life of women and
              create new employment opportunities for women and girls who
              otherwise may not have a clearly defined path in the tech
              ecosystem. We are passionate about bridging the digital gap and
              opening doors to women and girls which will help them attain a
              higher height in technological education and advancement.
              <b>We currently</b> have 414 registered members in 13 regions
              across the country.
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-basic pt-2">
      <div class="custom-container-fluid">
        <div class="row">
          <div class="col-md-12">
            <video poster="capture.jpg" id="player" playsinline controls>
              <source src="../../public/assets/sark.mp4" type="video/mp4" />
              <source src="../../public/assets/sark.mp4" type="video/webm" />
            </video>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-basic bg-light">
      <div class="custom-container-fluid">
        <div class="row">
          <div class="col-md-6">
            <h2 class="text-green font-weight-bold">
              Apply To Become A Member
            </h2>
            <p class="mb-5 mt-5">
              Are you a past GTL trainee? Then you can apply to become a member
              of our community. Below are some of the benefits individuals enjoy
              as members of the community.
            </p>
            <div class="row mb-5">
              <div class="col-md-4 text-center benefits">
                <img
                  src="../../public/assets/img/member-1.png"
                  style="width: 40px"
                  class="card-img-top"
                  alt="..."
                />
                <div class="text-green font-weight-bold">
                  Network with tech personalities
                </div>
              </div>
              <div class="col-md-4 text-center benefits">
                <img
                  src="../../public/assets/img/member-2.png"
                  style="width: 40px"
                  class="card-img-top"
                  alt="..."
                />
                <div class="text-green font-weight-bold">Real life mentors</div>
              </div>
              <div class="col-md-4 text-center benefits">
                <img
                  src="../../public/assets/img/member-3.png"
                  style="width: 40px"
                  class="card-img-top"
                  alt="..."
                />
                <div class="text-green font-weight-bold">Job Opportunies</div>
              </div>
            </div>
            <div class="apply-btn">
              <router-link
                to="/membership-application"
                class="btn btn-orange pl-5 pr-5"
                >Apply now</router-link
              >
            </div>
          </div>
          <div class="col-md-6 d-none d-md-block">
            <img
              src="../../public/assets/img/side-img.png"
              class="card-img-top w-75"
              alt="..."
            />
          </div>
        </div>
      </div>
    </div>
    <div class="section section-basic">
      <div class="custom-container-fluid">
        <div class="row">
          <div class="col-md-6">
            <img
              src="../../public/assets/img/become_member-1.png"
              class="card-img-top img-fluid"
              style="width: 630px; height: 500px; object-fit: cover;"
              alt="..."
            />
          </div>
          <div class="col-md-6">
            <h2 class="text-green font-weight-bold">
              Apply To Become A Mentor
            </h2>
            <h4 class="mt-5">
              Are you committed to the empowerment and success of Women in Ghana
              and Africa?. Then lend us your skills and make a difference in the
              lives of young women in Ghana!
            </h4>
            <h4 class="mb-5">
              As a mentor for the Ghana Ladies in Tech community, you will
              provide important professional, academic and social coaching,
              advice and support to your mentee. The end goal is to help your
              mentee with professional socialization, personal development and
              support in career development
            </h4>
            <div class="apply-btn">
              <router-link
                to="/"
                class="btn btn-orange pl-5 pr-5 text-sm-center"
              >
                Apply now
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="section section-basic mt-5">-->
    <!--      <div-->
    <!--        style="background-image: url('./assets/img/middleBack.png'); background-repeat:no-repeat; background-position-x: center; background-size:cover;"-->
    <!--      >-->
    <!--        <div class="container">-->
    <!--          <div class="row">-->
    <!--            <div class="col-md-7">-->
    <!--              <div class="card pt-5 pb-5" style="margin-top:-20px;">-->
    <!--                <div class="card-body">-->
    <!--                  <form>-->
    <!--                    <div class="form-row">-->
    <!--                      <div class="form-group col-md-6">-->
    <!--                        <label for="firstname" class="text-dark"-->
    <!--                          >First Name</label-->
    <!--                        >-->
    <!--                        <input-->
    <!--                          type="email"-->
    <!--                          class="form-control customInput"-->
    <!--                          id="firstname"-->
    <!--                        />-->
    <!--                      </div>-->
    <!--                      <div class="form-group col-md-6">-->
    <!--                        <label for="lastname" class="text-dark"-->
    <!--                          >Last Name</label-->
    <!--                        >-->
    <!--                        <input-->
    <!--                          type="email"-->
    <!--                          class="form-control customInput"-->
    <!--                          id="lastname"-->
    <!--                        />-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                    <div class="form-group">-->
    <!--                      <label for="inputAddress" class="text-dark"-->
    <!--                        >Email Address</label-->
    <!--                      >-->
    <!--                      <input type="email" class="form-control customInput" />-->
    <!--                    </div>-->
    <!--                    <div class="form-group">-->
    <!--                      <label for="region" class="text-dark">Region</label>-->
    <!--                      <select id="region" class="form-control customInput">-->
    <!--                        <option>Greater Accra</option>-->
    <!--                      </select>-->
    <!--                    </div>-->
    <!--                    <div class="form-group">-->
    <!--                      <label for="inputState" class="text-dark"-->
    <!--                        >Base Program Joined</label-->
    <!--                      >-->
    <!--                      <select id="inputState" class="form-control customInput">-->
    <!--                        <option>Greater Accra</option>-->
    <!--                      </select>-->
    <!--                    </div>-->
    <!--                    <div class="form-group">-->
    <!--                      <label for="inputAddress" class="text-dark"-->
    <!--                        >Base Program Date Completed</label-->
    <!--                      >-->
    <!--                      <input-->
    <!--                        type="text"-->
    <!--                        class="form-control customInput"-->
    <!--                        id="inputAddress"-->
    <!--                        placeholder="12/05/2020"-->
    <!--                      />-->
    <!--                    </div>-->
    <!--                    <div class="text-center">-->
    <!--                      <button type="submit" class="btn btn-orange">-->
    <!--                        Submit-->
    <!--                      </button>-->
    <!--                    </div>-->
    <!--                  </form>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="col-md-4 offset-md-1" id="become-member">-->
    <!--              <div-->
    <!--                style="background-image: url('./assets/img/join_us.png'); background-repeat:no-repeat; margin-top:100px;"-->
    <!--              >-->
    <!--                <h3-->
    <!--                  class="font-weight-bold text-green"-->
    <!--                  style="padding-top:32px;"-->
    <!--                >-->
    <!--                  Become A Member-->
    <!--                </h3>-->
    <!--              </div>-->
    <!--              <p class="text-justify mt-3">-->
    <!--                Want to join our Women In Tech and make an impact on other-->
    <!--                females in tech? Then complete the form below to appy for a-->
    <!--                memberhsip in our initiative.-->
    <!--              </p>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="section section-basic pt-2 bg-light">
      <div class="custom-container-fluid">
        <div class="row">
          <div class="col-md-12">
            <h2 class="pt-4 text-center font-weight-bold text-green">
              Upcoming Events
            </h2>
          </div>
          <div v-if="isLoading" class="col-md-12">
            <div class="row">
              <div class="col-md-4 col-lg-3" v-for="(e, i) in 4" :key="i">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="photo shine"></div>
                    <div class="lines shine" />
                    <div class="lines shine" />
                    <div class="lines shine" />
                    <div class="lines shine" />
                    <div class="lines shine" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="col-md-12">
            <div class="row">
              <div class="col-md-4 col-lg-3" v-for="(e, i) in events" :key="i">
                <div class="card">
                  <img :src="e['image']" class="card-img-top" alt="..." />
                  <!--              <span class="b-items__cars-one-img-type">Free</span>-->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3 col-lg-2 pr-0 pl-0">
                        <h4
                          class="mt-0 mb-0 font-weight-bold text-green sm-none"
                        >
                          {{ formatDate(e.date) }}
                        </h4>
                        <h6
                          class="mt-0 mb-0 font-weight-bold text-green md-none"
                        >
                          <span>{{ getFullDate(e.date) }} @ {{ e.time }}</span>
                        </h6>
                      </div>
                      <div
                        class="col-md-9 col-lg-10 pl-0 pr-0 mt-1 font-weight-bold text-capitalize"
                      >
                        {{ e.title }}
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-md-3 col-lg-2 pr-0 pl-0 d-none d-sm-block d-md-block d-lg-block"
                      >
                        <h3 class="font-weight-bold mt-0 sm-none">
                          {{ getDayFromDate(e.date) }}
                        </h3>
                      </div>
                      <div class="col-md-9 col-lg-10 pl-0 pr-0">
                        {{
                          (e.description || "").length > 200
                            ? (e.description || "").substring(0, 200) + "..."
                            : ""
                        }}
                      </div>
                      <div class="col-12 text-center mt-2" v-if="e.link">
                        <a
                          target="_blank"
                          :href="e.link"
                          class="btn btn-orange btn-sm"
                        >
                          Register to attend
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <downFooter />
  </div>
</template>

<script>
/* eslint-disable */
// import Swal from "sweetalert2";
import navbar from "../components/navbar";
import downFooter from "../components/footer";
import axios from "axios";
export default {
  name: "Home",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      details: {},
      height: 128,
      width: 128,
      events: [],
      members: [],
      slider: [
        {
          title:
            "Connecting &\n" + "Impacting Ladies\n" + "Through Technology\n",
          image: "./assets/img/slider-1.png"
        },
        {
          title:
            "Want to impact\n" +
            "knowledge Unto others?\n" +
            "apply to be a mentor",
          image: "./assets/img/slider-2.png"
        },
        {
          title: "Are you a past GTL\n" + "trainee? apply to\n" + "be a member",
          image: "./assets/img/slider-3.png"
        }
      ]
    };
  },
  components: {
    // Loading,
    downFooter,
    navbar
  },

  methods: {
    formatDate(d) {
      return moment(d).format("MMM");
    },
    getDayFromDate(d) {
      return d ? moment(d).format("D") : "";
    },
    getFullDate(d) {
      return d ? moment(d).format("DD MMM YYYY") : "";
    },

    getEvents() {
      this.isLoading = true;
      axios
        .get(
          "https://ladies-in-tech-webservice.azurewebsites.net/all-activities"
        )
        .then(res => {
          const { data } = res;
          this.events = data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getMembers() {
      axios
        .get("https://ladies-in-tech-webservice.azurewebsites.net/all-members")
        .then(res => {
          const { data } = res;
          this.members = data.data;
        });
    }
  },
  mounted: function() {
    let player = new Plyr("#player", {});
    player.source = {
      type: 'video',
      sources: [
        {
          src: 'https://www.youtube.com/watch?v=J9dm-yuosqU',
          provider: 'youtube',
        },
      ],
    };
    this.$loadScript(
      "https://cdn.jsdelivr.net/npm/moment@2.27.0/min/moment.min.js"
    ).then(() => {
      this.getEvents();
    });

    this.getMembers();
  },
  created() {}
};
</script>

<style scoped>
.card {
  border: 1px solid #cccc;
  box-shadow: none;
}

.index-page .page-header {
  height: 50vh;
}

.contact-list li {
  margin-bottom: 1.92rem;
  display: inline-flex;
}

.contact-list li i {
  padding-right: 1rem;
  padding-top: 4px;
}

@media screen and (min-width: 200px) and (max-width: 415px) {
  .h1-text {
    font-size: 20px !important;
  }
}

@media screen and (min-width: 416px) and (max-width: 823px) {
  .h1-text {
    font-size: 2.5rem !important;
  }
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.b-items__cars-one-img-type {
  border-radius: 5px;
  font: 700 10px "Open Sans", sans-serif;
  padding: 2px 5px;
  text-transform: uppercase;
  position: absolute;
  /* top: 15px; */
  z-index: 1000;
  background: white;
  top: 20px;
  left: 20px;
}

/*.carousel-inner:after {*/
/*  content: "";*/
/*  position: absolute;*/
/*  bottom: 0;*/
/*  width: 100%;*/
/*  background-image: url("../../public/assets/img/wave-bottom.svg");*/
/*  height: 279px;*/
/*}*/

.carousel .carousel-indicators {
  bottom: -1rem;
}

.carousel-caption {
  position: absolute;
  right: auto;
  /* bottom: 10%; */
  top: 30%;
  left: 20%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #ffffff;
  text-align: left;
}

.carousel-inner {
  overflow: visible;
}
.about {
  margin-top: 1rem;
}

@media screen and (max-width: 410px) {
  .h1-text {
    font-size: 20px !important;
  }
  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1rem;
  }
  h5 {
    font-size: 0.8rem;
  }

  .card .card-body {
    padding: 0.5rem 1.3rem;
  }
  .section {
    padding: 30px 0;
  }
  .benefits {
    margin-bottom: 1rem;
  }
}

@media screen and (max-width: 567px) {
  .carousel-inner:after {
    height: 100px;
  }
  .apply-btn {
    text-align: center;
  }
  .carousel .carousel-indicators {
    bottom: -2.3rem;
  }
  .about {
    margin-top: 0;
  }
}
@media screen and (max-width: 998px) {
  .carousel-inner img {
    height: auto;
    /*object-fit: cover;*/
  }
  .carousel-caption {
    top: 12%;
  }
}

@media screen and (max-width: 768px) {
  .sm-none {
    display: none;
  }
}
@media screen and (min-width: 769px) {
  .md-none {
    display: none;
  }
}
</style>
